import { useEffect, useRef, useState } from 'react';
import type { Notification, Message } from '@zimpel/AppHeader/Notification/domainTypes';

const AUTO_CLOSE_TIMEOUT_IN_MS = 5000;

// Only imported once at root level, do not use in other components
const useContextNotifications = () => {
  const [notification, setNotification] = useState<Notification|undefined>();
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const reset = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => setNotification(undefined), AUTO_CLOSE_TIMEOUT_IN_MS);
  };

  useEffect(() => () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    setNotification(undefined);
  }, []);

  return {
    notifyNotice: (message: Message) => { setNotification({ message, messageType: 'notice' }); reset(); },
    notifySuccess: (message: Message) => { setNotification({ message, messageType: 'success' }); reset(); },
    notifyError: (message: Message) => { setNotification({ message, messageType: 'error' }); reset(); },
    notify: (notification: Notification) => { setNotification(notification); reset(); },
    notification,
  };
};

export type UseNotificationsType = ReturnType<typeof useContextNotifications>;

export default useContextNotifications;
